import React from "react";

import Dashboard from "../../client_config/ppc_config/display/dashboard/Dashboard";

export default function Display(props) {
  return (
    <div style={{ backgroundColor: "#F5F5F5" }}>
      <Dashboard {...props} onboarding />
    </div>
  );
}
